<template>
	<div class="recruit" id="recruit">
		<div class="topFixed">
			<div class="top">
				<h1 class="logo" @click="back">
					红匣子游戏
				</h1>
				<ul class="nav">
					<li @click="back"><p>返回首页</p><span></span></li>
					<li class="on" ><p>加入我们</p><span></span></li>
				</ul>
				<!-- <div class="lang-nav" @click="langNavShow = !langNavShow">
					<ul v-if="langNavShow">
						<li class="on"><a href="www.baidu.com">简体中文</a></li>
						<li><a href="www.baidu.com">繁體中文</a></li>
						<li><a href="www.baidu.com">English</a></li>
						<li><a href="www.baidu.com">日本語</a></li>
						<li><a href="www.baidu.com">한국어</a></li>
					</ul>
				</div> -->
			</div>
		</div>
		<div class="mian">
			<div class="m m_1" id="m_1">
				<img src="@/assets/imgs/recruit/banner.jpg" width="100%"/>
			</div>
			<div class="m m_2" id="m_2">
				<div class="m_2_c">
					<div class="m_2_c_title">
						<p>岗位类别</p>
					</div>
					<div class="m_2_c_nav">
						<ul>
							<li :class="roleKey == 0? 'on':''" @click="onRoleKey(0)"><p>全部</p></li>
							<li v-for="(item, index) in recruitNav" :key="index" @click="onRoleKey(item.id)" :class="roleKey == item.id? 'on':''">
								<p>{{ item.desc }}</p>
							</li>
						</ul>
					</div>
				</div>
				<div class="m_2_search">
					<div class="m_2_search_c">
						<input type="text" v-model="keyword" placeholder="请输入职位关键字">
						<a @click="positionList(1, 5)">搜索</a>
					</div>
				</div>
			</div>
			<div class="m m_3" id="m_3">
				<div class="m_3_c">
					<ve-table
						id="loading-container"
						:columns="columns"
						:table-data="tableData"
						:border-around="false"
						:border-x="true"
						:border-y="false" />
					<div class="table-pagination">
						<ve-pagination
							:layout="['prev', 'pager', 'next', 'jumper']"
							:total="totalCount"
							:page-size="pageSize"
							:page-index="pageIndex"
							@on-page-number-change="pageNumberChange"
							@on-page-size-change="pageSizeChange"
						/>
					</div>
				</div>
			</div>
			<Footer class="m m_8 footer" id="m_8"/>
			<div class="popupbox" v-if="popupboxShow">
				<div class="popup">
					<div class="popupC">
						<div class="popupTitle">
							<span @click="popupboxShow=false">
								<i></i>
								<i></i>
							</span>
						</div>
						<div class="popupContent">
							<p class="title_1">{{ recruitDetail.job_name }}</p>
							<p class="detail_1">{{ recruitDetail.address }} / {{ recruitDetail.is_full_time }}</p>
							<!-- <p class="title_1">{{ recruitDetail.data1.title }}</p> -->
							<p class="title_1">职位描述</p>
							<p class="detail_2" v-html="recruitDetail.description"></p>
							<!-- <p class="title_1">{{ recruitDetail.data2.title }}</p> -->
							<p class="title_1">职位要求</p>
							<p class="detail_2" v-html="recruitDetail.requirements"></p>
							<p class="title_2" >简历请发送至：{{ recruitDetail.mail }}</p>
						</div>
						<div class="popupBtn">
							<a :href="recruitDetail.link" target="_blank">{{ recruitDetail.link_name }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import "@/assets/styles/index_pc.scss";
import Footer from "@/components/pc/Footer.vue";
import zhCN from "vue-easytable/libs/locale/lang/zh-CN";
import { getPositionList, getPositionType } from "@/api";
import { EscapeHtml } from '@/utils'

// import enUS from "vue-easytable/libs/locale/lang/en-US";
// this.$veLocale.use(enUS);

// 防刷
import debounce from "lodash/debounce";

// Simulation table data from database

export default {
    name: "recruit",
    components: {
			Footer
    },
    data () {
			return {
				loadingInstance: null,
				langNavShow: false,
				recruitNav: [],
				roleKey: 0,
				keyword: '',
				// page index
				pageIndex: 1,
				// page size
				pageSize: 2,
				totalCount: 0,
				columns: [
					{ field: "job_name", key: "b", title: "岗位名称", width: "25%", align: "center",
					renderBodyCell: ({ row, column, rowIndex }, h) => {
						const text = row[column.field];
						return (
								<span class="columnsName">{{ text }}</span>
							);
						},	
					},
					{ field: "role_selects", key: "c", title: "岗位性质", width: "25%", align: "center" },
					{ field: "update_time", key: "d", title: "发布时间", width: "25%", align: "center" },
					{ field: "操作", key: "e", title: "操作", width: "25%",
					renderBodyCell: ({ row, column, rowIndex }, h) => {
						return (
								<span class="columnsAction" on-click={() => this.detailRow(row)}>
									岗位详情
								</span>
							);
						},
					},
				],
				tableData: [],
				popupboxShow: false,
				recruitDetail: {
					name: '',
					address: '',
					time: '',
					description: '',
					requirements: '',
					linkName: '',
					link: '',
					mail: ''
				}
			};
    },
		computed: {
		},
    mounted () {
			this.handleLoading();
    },
    methods: {
			/**
			 * @function handleLoading 处理加载
			 */
			handleLoading(){
				console.log("初始化")
				this.$veLocale.use(zhCN);
				this.loadingInstance = this.$veLoading({
					target: document.querySelector("#loading-container"),
					name: "grid",
				});
				this.positionType();
				this.positionList(1, 5)
			},
			/**
			 * @function back 回到主页
			 */
			back() {
				// this.$router.push({path: "/"})
				let url1 = window.location.host;
				console.log('url1', url1)
				console.log('url1', "http://"+url1+"/zh")
				window.location.href= "http://"+url1+"/zh"
			},

			// page number change
			pageNumberChange(pageIndex) {
				this.pageIndex = pageIndex;
			},

			// page size change
			pageSizeChange(pageSize) {
				this.pageIndex = 1;
				this.pageSize = pageSize;
			},

			// Simulation table data
			initDatabase() {
				this.tableData = [],
				setTimeout(() => {
				}, 100);
			},

			// 搜索菜单
			onRoleKey(id) {
				this.roleKey = id;
				this.positionList(1, 5)
			},

			// 类别列表
			positionType() {
				getPositionType({lang:'zh-cn'})
					.then(res => {
						console.log("岗位类别成功", res);
						console.log("岗位类别成功", res.data);
						this.recruitNav = res.data;
					})
					.catch(err => {
						console.log("岗位类别失败", err);
					});
			},


			// 岗位列表
			positionList(pageIndex, pageSize) {
				this.loadingInstance.show();
				let positionData = {
					lang: 'zh-cn', 
					pageSize: pageSize, 
					pageIndex: pageIndex,
					roleKey: this.roleKey,
					keyword: this.keyword
				};
				getPositionList(positionData)
					.then(res => {
						console.log("岗位列表成功", res);
						console.log("岗位列表成功", res.data.list);
						this.tableData = res.data.list;
						this.totalCount = res.data.total;
						this.pageSize = pageSize;
						this.pageIndex = pageIndex;
						this.loadingInstance.close();
						
					})
					.catch(err => {
						console.log("岗位列表失败", err);
						this.loadingInstance.close();
					});
			},
			
			// 岗位详情
			detailRow(data) {
				console.log('detailRow', data),
				this.popupboxShow = true;
				this.recruitDetail = data;
				this.recruitDetail.description = EscapeHtml(data.description);
				this.recruitDetail.requirements = EscapeHtml(data.requirements);
				console.log('detailRow2', this.recruitDetail)
			}
    },
		destroyed() {
			this.loadingInstance.destroy();
		},
};
</script>

<style lang="scss">
@import "../../assets/styles/index_pc.scss";
</style>
